<div class="containt-body">
    <div class="r-box">
        <!-- <div class="r-box-header">
            Program Details
        </div> -->
        <div class="r-box-body row pd-l15">
            <div class="col mx-1 counter" *ngIf="totalHours > 0">
                <p class="counter-title">Program Journey</p>
                <span class="counter-number">{{totalHours}}</span><span class="counter-unit"> Hrs</span>
            </div>
            <div class="col mx-1 counter" *ngIf="metrics?.metrics?.weeks > 0">
                <p class="counter-title">Duration</p>
                <span class="counter-number">{{metrics?.metrics?.weeks}}</span>
                <span class="counter-unit"> Weeks</span>
            </div>
            <div class="col mx-1 counter" *ngIf="metrics?.learnerCount > 0">
                <p class="counter-title">Learners</p>
                <span class="counter-number">{{filteredUsers?.length}}</span>
            </div>
            <div class="col mx-1 counter" *ngIf="metrics?.metrics?.masterClasses">
                <p class="counter-title">Live Sessions</p>
                <span class="counter-number">{{metrics?.metrics?.masterClasses}}</span>
            </div>
            <div class="col mx-1 counter" *ngIf="metrics?.metrics?.courses">
                <p class="counter-title">Courses</p>
                <span class="counter-number">{{metrics?.metrics?.courses}}</span>
            </div>
            <div class="col mx-1 counter" *ngIf="assessments > 0">
                <p class="counter-title">Assessments</p>
                <span class="counter-number">{{assessments}}</span>
            </div>
        </div>
    </div>

    <!-- <div class="row"> -->
    <div class="r-box-body mg-t50 mg-b50">
        <div class="r-box-header center mg-b35 text-center">
            Key Parameters to Monitor
        </div>
        <!-- <div class="r-box-body center mg-b70">
            <h2>The Overall Health of the program will be displayed here.</h2>
        </div> -->
        <div class="row justify-content-center circular-holder">
            <div class="col-lg-3 col-md-4 col-sm-7 col-7 circleProgress">
                <ng-template #tooltip1 class="tooltip-template">
                    <p><b>Are learners engaged?</b></p>
                    <p>Ratio of program journey completed by learners to ideal completion on a pro-rata basis.</p>
                    <ul>
                        <li><span class="dot red"></span> 0 - 25</li>
                        <li><span class="dot yellow"></span> 25 - 50</li>
                        <li><span class="dot green"></span> 50+</li>
                    </ul>
                  </ng-template>
                <app-circular-progress radius="80" [currentValue]="engagmentDataPoints ? engagementHealth : 0" [outerColor]="engagmentDataPoints ? engagementHealthColor : '#E1E1E1'" class="engagement" [title]="engagmentDataPoints && engagementHealth > 10 ? ['test','test'] : ['test','test','test','test','test']" [titleColor]="'transparent'" [subTitle]="engagmentDataPoints && engagementHealth > 10 ? engagementHealth + '/100' : ['Available 7 days','from prog start']" [subTitleSize]="engagmentDataPoints && engagementHealth > 10 ? 26 : 14"></app-circular-progress>
                <div class="text-holder">
                    <h3>Engagement</h3>
                    <img src="/assets/new-dashboard/info.png" [ngbTooltip]="tooltip1" placement="top"  class="info" [innerHTML]="toolTipeIcon">
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-7 col-7 circleProgress">
                <ng-template #tooltip2 class="tooltip-template">
                    <p><b>Are learners following the learning material? </b></p>
                    <p>Aggregate of in-course graded assessments.</p>
                    <ul>
                        <li><span class="dot red"></span> 0 - 33.33</li>
                        <li><span class="dot yellow"></span> 33.33 - 66.66</li>
                        <li><span class="dot green"></span> > 66.66</li>
                    </ul>
                  </ng-template>
                <app-circular-progress radius="80" [currentValue]="scoresHealth" [outerColor]="scoresHealth > 0 ? scoreHealthColor : '#E1E1E1'" class="retention" [title]="scoresHealth > 0 ? ['test','test'] : ['test','test','test','test','test']" [titleColor]="'transparent'" [subTitle]="scoresHealth > 0 ? scoresHealth + '/100' : ['Need min. 10 graded','course completions']" [subTitleSize]="scoresHealth > 0 ? 26 : 14"></app-circular-progress>
                <div class="text-holder">
                    <h3>Knowledge Retention</h3>
                    <img src="/assets/new-dashboard/info.png" [ngbTooltip]="tooltip2" placement="top"  class="info" [innerHTML]="toolTipeIcon">
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-7 col-7 circleProgress">
                <ng-template #tooltip3 class="tooltip-template">
                    <p><b>Are learners connecting with the program journey? </b></p>
                    <p>Aggregate of ratings-based feedback from learners.</p>
                    <ul>
                        <li><span class="dot red"></span> 0 - 40</li>
                        <li><span class="dot yellow"></span> 40 - 75</li>
                        <li><span class="dot green"></span> 75 - 100</li>
                    </ul>
                  </ng-template>
                <app-circular-progress radius="80" [currentValue]="ratingsHealth" [outerColor]="ratingsHealth > 0 ? ratingHealthColor : '#E1E1E1'" class="feedback" [title]="ratingsHealth > 0 ? ['test','test'] : ['test','test','test','test','test']" [titleColor]="'transparent'" [subTitle]="ratingsHealth > 0 ? ratingsHealth + '/100' : ['Need min. 10','learner ratings']" [subTitleSize]="ratingsHealth > 0 ? 26 : 14"></app-circular-progress>
                <!-- <div class="gif-circle" *ngIf="ratingsHealth <= 10">
                    <span class="circle">
                        <img class="img-responsive" src="/assets/new-dashboard/placeholder.png">
                        <p>Need min. 10 learner ratings</p>
                    </span>
                </div> -->
                <div class="text-holder">
                    <h3>Learner Feedback</h3>
                    <img src="/assets/new-dashboard/info.png" [ngbTooltip]="tooltip3" placement="top"  class="info" [innerHTML]="toolTipeIcon">
                </div>
            </div>
        </div>
    </div>

    <!-- slider code -->
    <div class="home-page-slider mg-b50">
        <div class="r-box-header center mg-t30 mg-b50">
            Program Elements
        </div>
        <carousel [cellsToShow]="cellstoshow" [margin]="20" class="custom-carousel">
            <div *ngFor="let element of elements" class="carousel-cell">
                <ng-container *ngIf="element">
                    <div class="slider-header center">
                        <div [class]="element?.past ? 'pill green' : 'pill grey'">
                            {{element.type === 'PRE' ? 'Start' : element.type === 'POST' ? 'End' : element?.past ? 'Unlock Date: ' +
                            element.startDateString : 'Unlock Date: ' + element.startDateString}}
                        </div>
                    </div>
                    <a [routerLink]="'/learning-insights/block/' + element.title">
                        <div [class]="element.type === 'MASTERCLASS' ? 'r-box yellow' : 'r-box'">
                            <div class="rating-holder" *ngIf="element.type === 'MASTERCLASS'">
                                <app-star-rating style="font-size: 14px"
                                    [starColor]="element.avgRating != 'NA' ? '#ff2400' : '#ff2400'"
                                    *ngIf="element.type !== 'PRE' && element.type !== 'POST' && element.type !== 'ASSESSMENT'"
                                    [starRating]="element.avgRating" [starSize]="1.6"></app-star-rating>
                            </div>
                            <div class="rating-holder" *ngIf="element.type != 'MASTERCLASS'">
                                <app-star-rating style="font-size: 14px"
                                    [starColor]="element.avgRating != 'NA' ? '#ff2400' : '#ff2400'"
                                    *ngIf="element.type !== 'PRE' && element.type !== 'POST' && element.type !== 'ASSESSMENT'"
                                    [starRating]="element.avgRating" [starSize]="1.6"></app-star-rating>
                            </div>
                            <div class="pill card-header white" *ngIf="element.type === 'MASTERCLASS'">
                                {{element.title.toLowerCase().includes('thrive live') ? 'Thrive Live' : typeTitle[element.type]}}
                            </div>
                            <div class="pill card-header grey" *ngIf="element.type === 'COURSE'">
                                {{element.title.toLowerCase().includes('thrive master') ? 'Thrive Master' :
                                typeTitle[element.type]}}
                            </div>
                            <div class="pill card-header grey" *ngIf="element.type === 'PRE' || element.type === 'POST'">
                                {{typeTitle[element.type]}}
                            </div>
                            <div class="pill card-header grey" *ngIf="element.type === 'ASSESSMENT'">
                                {{element.title.toLowerCase().includes('thrive drill') ? 'Thrive Drill' : typeTitle[element.type]}}
                            </div>
                            <span class="pd-l10" *ngIf="element.type === 'MASTERCLASS'"><i
                                    class="fa fa-video-camera iconMiddle"></i></span>
                            <h1 class="font-32 mg-t10">{{element.title.toLowerCase( )}}</h1>
                            <p class="description">{{(element?.description | slice:0:80) + (element?.description?.length > 80 ?
                                '...' : '')}}</p>
                            <div class="w-100 d-flex">
                                <div *ngIf="element.completedPercent > 0"
                                    [style.width.%]="element.completedPercent <= 15 ? auto : element.completedPercent - 1"
                                    [class]="'pill font-13 mg-r3 mg-t20 w-' + element.completedPercent + ' green'">
                                    {{element.completed}}
                                </div>
                                <div *ngIf="element.inProgressPercent > 0"
                                    [style.width.%]="element.inProgressPercent <= 15 ? auto : element.inProgressPercent - 1"
                                    [class]="'pill font-13  progress-pills mg-r3 mg-t20 w-' + element.inProgressPercent + ' blue'">
                                    {{element.inProgress}}
                                </div>
                                <div *ngIf="element.notStartedPercent > 0"
                                    [style.width.%]="element.notStartedPercent <= 15 ? auto : element.notStartedPercent - 1"
                                    [ngClass]="element.startDate > todaysDate ? 'grey' : 'red'"
                                    [class]="'pill font-13 progress-pills mg-t20 w-' + element.notStartedPercent">
                                    <img src="/assets/new-dashboard/lock.png" alt="image" class="lock"
                                        *ngIf="element.startDate > todaysDate">{{element.notStarted}}
                                </div>

                            </div>
                            <p class="mg-t20 font-14">{{element.type !== 'MASTERCLASS' ? 'Average Score:' : 'Total Attendance:'}}
                                <span class="font-32" [class]="element.type === 'MASTERCLASS' ? 'font-white' : ''"> {{element.type
                                    !== 'MASTERCLASS' ? element.avgScore : (element.completed > 0 ? element.completed :
                                    'NA')}}</span></p>
                        </div>
                    </a></ng-container>
                <!-- {{element | json}} -->

            </div>
        </carousel>

        <div class="r-box-body pd-l10 table-bottom">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-4 col-12 download-before">
                    <button class="mg-r30 font-12 cursor-pointer" (click)="downloadProgramReport()">Download Report</button>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8 col-12 status font-12">
                    <div class="mg-r20"><span class="dot green"></span>Completed</div>
                    <div class="mg-r20"><span class="dot blue"></span>Ongoing</div>
                    <div class="mg-r20"><span class="dot red"></span>Not Started</div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-12 download-after">
                    <button class="mg-r30 font-12 cursor-pointer" (click)="downloadProgramReport()">Download Report</button>
                </div>
            </div>
        </div>
    </div>

    <div class="mg-b40">
        <div class="r-box-body program-report row text-center">

            <div class="col-md-12 col-sm-12 col-lg-8 mg-auto">
                <div class="r-box-header">
                    <div class="center font-32 mg-b50">
                        Completion Summary (%)
                    </div>
                </div>

                <div class="r-box">
                    <div class="r-box-body">
                        <p class="font-16" *ngIf="avgProgress >= 0">Overall Program<span>{{avgProgress}}%</span></p>
                        <p class="font-16" *ngIf="progress[1] >= 0">Pre-assessment<span>{{progress[1]}}%</span></p>
                        <p class="font-16" *ngIf="progress[4] >= 0">Unlocked Live Sessions<span>{{progress[4]}}%</span></p>
                        <p class="font-16" *ngIf="progress[3] >= 0">Unlocked Courses<span>{{progress[3]}}%</span></p>
                        <p class="font-16" *ngIf="progress[2] >= 0">Post-assessment<span>{{progress[2]}}%</span></p>
                        <p class="font-16" *ngIf="progress[5] >= 0">Unlocked Habit Drills<span>{{progress[5]}}%</span></p>
                        <p class="font-16" *ngIf="progress[6] >= 0">Unlocked Thrive Drills<span>{{progress[6]}}%</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="r-box-body data-table mg-b50">
        <div class="r-box-header ">
            <div class="center mg-b50 position-relative">
                Program Leaderboard
                <div class="table-sort">
                    <div ngbDropdown class="d-inline-block">
                        <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
                            {{selectedValue ? selectedValue : 'Sort'}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-down-values">
                            <button *ngFor="let option of dropDownData" ngbDropdownItem (click)="onSortChange(option.value, option.name)">{{option.name}}</button>

                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="r-box-body scrollable table-responsive w-100 pd-b10">
            <table class="table">
                <thead class="font-16">
                    <th class="pd-l5 th-width-200">Learner's Name</th>
                    <th class="th-width-200">Last Login</th>
                   <!-- <th>Department</th> -->
                    <th class="th-width-200">Completion</th>
                    <th *ngIf="avgScore > 0" class="th-width-200">Program Score/100</th>
                    <th class="th-width-200">Email</th>
                    <th class="th-width-200">Time Spent</th>
                </thead>
                <tbody>
                    <tr class="average-holder">
                        <td class="leader-name">Cohort Average</td>
                        <td></td>
                        <td class="pd-r90 pd-t5">
                            <app-progress-bar colorValue="success"  maxValue="100" [progressValue]="avgProgress" showTitle="true"></app-progress-bar>
                        </td>
                        <td class="font-14 font-weight-bold pd-r20" *ngIf="avgScore > 0">
                            <span class="pill pd-r20" [ngClass]="{'grey': avgScore === 0}">{{avgScore > 0 ? avgScore : 'NA'}}</span></td>
                        <td class="font-14 pd-l40 pd-t5"></td>
                      <td class="font-14 font-weight-bold pd-r20">
                        {{(avgTimeSpent.totalTime != 0 && avgTimeSpent.count !=0 ? ( avgTimeSpent.totalTime/avgTimeSpent.count | formateSeconds: 'hm') : '-') }}
                      </td>
                    </tr>
                    <tr style="height: 15px;"><span></span></tr>
                    <tr *ngFor="let leader of filteredUsers | paginate: {itemsPerPage: 10, currentPage:page, id: '1'}; let i = index">
                        <td class="leader-name">{{leader.name}}</td>
                        <td class="font-14" *ngIf="leader.daysSinceLogin < 0">{{leader.daysSinceLogin < 0 ? 'Never Logged in' : ''}}</td>
                        <td class="font-14" *ngIf="leader.daysSinceLogin > 0">{{leader.daysSinceLogin === 1 ? leader.daysSinceLogin + ' day ago' : leader.daysSinceLogin + ' days ago'}}</td>
                        <td class="font-14" *ngIf="leader.daysSinceLogin === 0">{{leader.daysSinceLogin === 0 ? 'Today' : leader.daysSinceLogin + ' days ago'}}</td>
                        <!-- <td>{{leader.Department}}</td> -->
                        <td class="pd-r90">
                            <app-progress-bar colorValue="success"  maxValue="100" [progressValue]="leader.progress" showTitle="true"></app-progress-bar>
                        </td>
                        <td class="font-14 pd-r20 font-weight-bold pd-t0" *ngIf="avgScore > 0"><span class="pill" [ngClass]="{'grey': leader.programpercentage === 0}">{{leader.programpercentage > 0 ? leader.programpercentage : 'NA'}}</span></td>
                        <td class="font-14">{{leader.email}}</td>
                        <td class="font-14" style="width: 100%">{{learnerMap?.[leader.email]?.timeSpent ? (learnerMap?.[leader.email]?.timeSpent | formateSeconds: 'hm' ): '-'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row table-button pd-l10">
            <div class="col-lg-3 col-md-4 col-sm-4 col-6 pd-t5">
                <button class="mg-r30 font-12 cursor-pointer" (click)="downloadReport()">Download Report</button>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-8 col-6">
                <app-table-pagination (pageChange)="page = $event" id="1" maxSize="10" directionLinks="true" autoHide="true" [totalListCount]="filteredUsers ? filteredUsers.length : 0"></app-table-pagination>
            </div>
        </div>
    </div>

    <div class="mg-b50" *ngIf="metrics?.ratings > 0">
        <div class="text-center center mg-b30 r-box-header">
            Program Ratings & Top Takeaways
        </div>
        <div class="r-box-body program-rating row">
            <div class="col-md-12 col-sm-12" [ngClass]="takeAwaysFilter(filteredUsers).length > 0 ? 'col-lg-4': 'col-lg-12'" *ngIf="metrics?.ratings > 0">
                <div class="r-box minHeight-350 mg-b0">
                    <div class="r-box-header font-weight-bold pd-b10">
                        Program Rating
                    </div>
                    <div class="r-box-body" >
                        <div class="rating-container">
                            <app-star-rating [starRating]='metrics?.avgRating ? metrics?.avgRating.toFixed(1) : 0' ></app-star-rating>
                        </div>
                        <p>({{metrics?.ratings}} Ratings)</p>
                        <div>
                            <p class="rating-list row">
                                <span class="col-2 rating-value font-14">5 ★</span>
                                <app-progress-bar class="col-8" colorValue="upgrad" [maxValue]="metrics?.ratings ? metrics.ratings * 1000 : 1000" [progressValue]="metrics?.ratingsHistogram ? metrics.ratingsHistogram[4] * 1000 : 0" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value font-14">{{metrics?.ratingsHistogram ? metrics.ratingsHistogram[4] : 0}}</span>
                            </p>
                            <p class="rating-list row">
                                <span class="col-2 rating-value font-14">4 ★</span>
                                <app-progress-bar class="col-8" colorValue="upgrad" [maxValue]="metrics?.ratings ? metrics.ratings * 1000 : 1000" [progressValue]="metrics?.ratingsHistogram ? metrics.ratingsHistogram[3] * 1000 : 0"  showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value font-14">{{metrics?.ratingsHistogram ? metrics.ratingsHistogram[3] : 0}}</span>
                            </p>
                            <p class="rating-list row">
                                <span class="col-2 rating-value font-14">3 ★</span>
                                <app-progress-bar class="col-8" colorValue="upgrad" [maxValue]="metrics?.ratings ? metrics.ratings * 1000 : 1000" [progressValue]="metrics?.ratingsHistogram ? metrics.ratingsHistogram[2] * 1000 : 0"  showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value font-14">{{metrics?.ratingsHistogram ? metrics.ratingsHistogram[2] : 0}}</span>
                            </p>
                            <p class="rating-list row">
                                <span class="col-2 rating-value font-14">2 ★</span>
                                <app-progress-bar class="col-8" colorValue="upgrad" [maxValue]="metrics?.ratings ? metrics.ratings * 1000 : 1000" [progressValue]="metrics?.ratingsHistogram ? metrics.ratingsHistogram[1] * 1000 : 0"  showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value font-14">{{metrics?.ratingsHistogram ? metrics.ratingsHistogram[1] : 0}}</span>
                            </p>
                            <p class="rating-list row">
                                <span class="col-2 rating-value font-14">1 ★</span>
                                <app-progress-bar class="col-8" colorValue="upgrad" [maxValue]="metrics?.ratings ? metrics.ratings * 1000 : 1000" [progressValue]="metrics?.ratingsHistogram ? metrics.ratingsHistogram[0] * 1000 : 0" showTitle="false"></app-progress-bar>
                                <span class="col-2 rating-value font-14">{{metrics?.ratingsHistogram ? metrics.ratingsHistogram[0] : 0}}</span>
                            </p>
                        </div>
                    </div>

                </div>

            </div>
            <div class="col-lg-8 col-md-12 col-sm-12" *ngIf="takeAwaysFilter(filteredUsers).length > 0">
                <div class="r-box pd-b20 mg-b0">
                    <div class="r-box-header font-weight-bold">
                        Top Takeaways
                    </div>
                    <div class="r-box-body top-takeaways row"  [@slideInOut]="openDiv" >
                        <div class="col-lg-6 col-sm-12" *ngFor="let takeaways of takeAwaysFilter(filteredUsers)">
                            <div class="takeaway-box ">
                                <p class="takeaway-user mg-b10">{{takeaways.name}}</p>
                                <p class="takeaway-message">{{takeaways.threekeytakeaways}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="toggle-buttons">
                        <button class="viewmore font-14" (click)="takeawaysToggle()">
                            <span id="viewmore" *ngIf="openDiv === 'out'">View More</span>
                            <span id="viewless" *ngIf="openDiv === 'in'">View Less</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
